<script>
    import Fa from "svelte-fa";
    import { faTrash } from '@fortawesome/free-solid-svg-icons'
    import {
        Dialog,
        DialogOverlay,
        DialogTitle,
        DialogDescription,
    } from "@rgossiaux/svelte-headlessui";
    import { createEventDispatcher } from "svelte";
    import Button from "../ui/Button.svelte";
    
    export let stamp;

    const dispatch = createEventDispatcher();

    function confirm() {
        dispatch("remove", stamp)
        open = false;
    }

    function cancel() {
        open = false;
    }

    let open = false;
</script>


<Dialog class="dialog" open={open} on:close={cancel}>
    <DialogOverlay class="dialog-overlay"/>
    <div class="dialog-content">
        <DialogTitle class="dialog-title">Stempel archivieren</DialogTitle>
        <DialogDescription class="dialog-description">
            Bist du dir sicher, dass du den Stempel "{stamp.name}" archivieren möchtest? Der entfernte Stempel wird nicht mehr neu vergeben, bleibt aber auf den alten Karten noch erhalten.
        </DialogDescription>
        
        <div class="dialog-options">
            <Button on:click={cancel}>
                Abbrechen
            </Button>
            <Button intent="danger" on:click={confirm}>
                Stempel archivieren
            </Button>
        </div>
    </div>
</Dialog>

<Button transparent on:click={() => {open = true}}>
    <Fa icon={faTrash} slot="icon"/>
</Button>